import PolicyShell from "./legal/PolicyShell";
import { AML_POLICY } from "./legal/data/amlPolicy";

export default function AmlPolicyPage() {
  return <PolicyShell data={AML_POLICY} />;
}
